var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-facebook-api-history"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("Meta広告 API送信履歴")])])],1),_c('FacebookLogTable',{attrs:{"pageType":'ctrl'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }